import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/imgs/logo2.32a2f0e40fc629cb6e51.png";
import ErrorMssg from "../../Components/ErrorMssg/ErrorMssg";
import LanguageSelector from "../../Components/Language-selector";
import { useLibyaSignupLogic } from "../SignUp/libya/useLibyaSignupLogic";
import "./Marketing3Page.css";

/**
 * Libya signup — arcade brawler / "ROUND 1" fight skin (lime × magenta).
 * Route: /marketing3
 */
const Marketing3Page = () => {
  const { t, i18n } = useTranslation();
  const {
    errMsg,
    msisdn,
    otp,
    setOtp,
    isOTP,
    setIsOTP,
    isLoading,
    isValidMsisdn,
    onSubmit,
    onVerifyOtp,
    allowOnlyNumbers,
    handleMsisdnChange,
  } = useLibyaSignupLogic();

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n, i18n.language]);

  return (
    <div className="mkt3" dir={i18n.dir()}>
      <div className="mkt3-vignette" aria-hidden />
      <div className="mkt3-burst" aria-hidden />
      <div className="mkt3-hazard-bottom" aria-hidden />
      <div className="mkt3-grain" aria-hidden />

      <div className="mkt3-inner">
        <div className="mkt3-top">
          <div className="mkt3-round-pill" aria-hidden>
            <span className="mkt3-round-k">ROUND</span>
            <span className="mkt3-round-n">1</span>
            <span className="mkt3-ready">READY</span>
          </div>
          <LanguageSelector />
        </div>

        <header className="mkt3-hud" aria-hidden>
          <div className="mkt3-hp mkt3-hp--a">
            <span className="mkt3-hp-lbl">1P</span>
            <div className="mkt3-hp-bar">
              <i className="mkt3-hp-juice mkt3-hp-juice--a" />
            </div>
          </div>
          <div className="mkt3-ko">K.O.</div>
          <div className="mkt3-hp mkt3-hp--b">
            <div className="mkt3-hp-bar mkt3-hp-bar--rev">
              <i className="mkt3-hp-juice mkt3-hp-juice--b" />
            </div>
            <span className="mkt3-hp-lbl">2P</span>
          </div>
        </header>

        {!isOTP && (
          <>
            <div className="mkt3-hero">
              <div className="mkt3-logo-frame">
                <div className="mkt3-logo-ring" />
                <img
                  className="mkt3-logo servImg cptpl_logo"
                  src={logo}
                  alt="Gamer Club"
                />
              </div>
              <h1 className="mkt3-title">{t("SubscribeNowText")}</h1>
              <p className="mkt3-sub cptpl_service d-block">
                {t(
                  "compete in tournaments and track their performance through leaderboards. It offers a space for both casual and competitive players across various games."
                )}
              </p>
            </div>

            <div className="mkt3-card">
              <form onSubmit={onSubmit} className="mkt3-form">
                <div className="mkt3-row">
                  <input
                    value="218"
                    readOnly
                    className="form-control mkt3-prefix"
                  />
                  <input
                    type="text"
                    placeholder={t("Enteryourmobilenumber")}
                    className="form-control mkt3-input"
                    value={msisdn}
                    onChange={handleMsisdnChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    autoComplete="tel-national"
                  />
                </div>
                {msisdn.length > 0 && !isValidMsisdn && (
                  <small className="mkt3-hint">
                    {msisdn.startsWith("218")
                      ? t(
                          "Mobile number must be 12–13 digits when starting with 218"
                        )
                      : t("Mobile number must be 9 digits")}
                  </small>
                )}

                <button
                  type="submit"
                  className="mkt3-btn cptpl_subscribe"
                  id="cta_button"
                  disabled={isLoading || !isValidMsisdn}
                >
                  <span className="mkt3-btn-shine" aria-hidden />
                  {isLoading ? t("Processing") : t("subscribe")}
                </button>
              </form>
            </div>

            <div className="mkt3-terms" style={{ direction: "rtl" }}>
              <p className="price_text price_title-3 cptpl_price">
                {t("New_subscribers_weekly_ts_libyaF")}
                <br />
                {t("New_subscribers_monthly_ts_libyaF")}
              </p>
              <p className="cptpl_terms">
                {t("New_subscribers_ts_libya_condition")}
              </p>
              <p>
                <a href="/terms">{t("terms_of_service")}</a>
                {" · "}
                <a href="/privacy">{t("privacy_policy")}</a>
              </p>
            </div>
          </>
        )}

        {isOTP && (
          <div className="mkt3-card mkt3-card--otp">
            <h2 className="mkt3-otp-title">{t("OTP VERIFICATION")}</h2>
            <p className="mkt3-otp-sub">
              {t("Enter the OTP sent to")} — <b>{msisdn}</b>
            </p>
            <form onSubmit={onVerifyOtp} className="mkt3-form-otp">
              <input
                className="form-control mkt3-input mkt3-otp-in text-center"
                maxLength="4"
                placeholder={t("EnteryourOTP")}
                value={otp}
                onKeyDown={allowOnlyNumbers}
                onChange={(e) => setOtp(e.target.value)}
                inputMode="numeric"
                autoComplete="one-time-code"
              />
              <button
                type="submit"
                className="mkt3-btn"
                disabled={isLoading || otp.length !== 4}
              >
                <span className="mkt3-btn-shine" aria-hidden />
                {isLoading ? "…" : t("Confirm")}
              </button>
              <button
                type="button"
                className="mkt3-btn-ghost"
                onClick={() => setIsOTP(false)}
              >
                {t("Back")}
              </button>
            </form>
          </div>
        )}

        {errMsg ? (
          <div className="mkt3-error">
            <ErrorMssg errMsg={errMsg} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Marketing3Page;
